import { render, staticRenderFns } from "./BoostBuffetOrPartyEventTag.vue?vue&type=template&id=21d49faa&"
import script from "./BoostBuffetOrPartyEventTag.vue?vue&type=script&lang=js&"
export * from "./BoostBuffetOrPartyEventTag.vue?vue&type=script&lang=js&"
import style0 from "./BoostBuffetOrPartyEventTag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports